import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function Card({ 
  title, 
  description, 
  children, 
  className = '',
  footer
}) {
  return (
    <div className={twMerge(
      'bg-white rounded-xl shadow-md hover:shadow-lg transition-shadow duration-200',
      className
    )}>
      {(title || description) && (
        <div className="p-6 border-b border-ebony/20">
          {title && <h3 className="text-lg font-semibold text-midnight font-heading">{title}</h3>}
          {description && <p className="mt-1 text-sm text-ebony">{description}</p>}
        </div>
      )}
      
      <div className="p-6">{children}</div>
      
      {footer && (
        <div className="px-6 py-4 bg-old-lace/30 border-t border-ebony/20 rounded-b-xl">
          {footer}
        </div>
      )}
    </div>
  );
}